import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import {
	BaseComponent,
	CardAccessComponent,
	DashboardComponent,
	SpinnerComponent,
	TileComponent,
	TopnavComponent,
	WatermarkComponent,
} from '@tecalisdev/infinity';
import { LocalStorageKeys } from 'src/app/core/models/auth.models';
import { AuthService } from 'src/app/core/services/auth.service';
import { DesignService } from 'src/app/shared/services/config/design.service';
import { TestsService } from '../../services/tests.service';

@Component({
	selector: 'app-tests',
	templateUrl: './tests.component.html',
	styleUrls: ['./tests.component.scss'],
	imports: [
		BaseComponent,
		TopnavComponent,
		DashboardComponent,
		TileComponent,
		CardAccessComponent,
		WatermarkComponent,
		SpinnerComponent,
	],
})
export class TestsComponent {
	// eslint-disable-next-line @typescript-eslint/ban-types
	Bolean: Boolean;
	public profiles = {
		es: {
			pwcsa: '0198cb46-4616-7d2c-8671-4e3212d00c96',
			pwcsb: '0198cb49-fb30-78c1-b9a0-d9c9f7c1bf83',
			pwcsTest2: '0199dc3d-99ba-7491-a03e-63482e3cf091',
			pwcsMarketingDemo: '0199f0b8-5bf4-7510-819d-244ed8991d55',
			onlyOcr: '0198bd5a-4a7f-7a13-a76f-dfd98c5b7865',
			onlyPol: '0198bd5b-a5d9-7532-aeb4-d5b05936a36d',
			onlyDoc: '0198cb55-b6b4-709b-aa6d-618eaeaf439a',
			choose: '0198cb49-1234-4321-1111-d9c9f7c1bf83',
			genericDocument: '0cc0393b-f2aa-446e-b768-75fb95b09936',
			ocrAndBankscoring: '019a970c-22c2-73c5-a7e3-07d212ab0cdd',
			ocrAndIrpf: '019a970b-3101-79fe-9fc8-a032ca6cf8d8',
			ocrAndScripture: '019a970d-0fd9-79ab-90ac-4fda2e0f6028',
			ocrAndWorklife: '019a970b-562f-7ee9-b447-612d259b8489',
			sura: '019b2d5f-a2a5-7333-a6af-c4faf1aadfcc',
			video: '019c7c31-17a1-718e-b19f-f812ede950d9',
		},
		en: {
			pwcsa: '0198cb46-4616-7d2c-1645-4e3212d00f66',
			pwcsb: '0198cb49-fb30-78c1-8765-d9f9c7c1ba25',
		},
		tecalisTests: {
			a: 'db50cefb-d9e5-4b99-9683-f9b677acc9c8',
			b: '9df51eff-f39a-464b-886d-eeeb7fda19cb',
			c: 'df51c5ee-8aae-4ebb-bd2d-6d42e1346d8a',
			d: 'e80d77e0-8706-44e9-af1c-16fe3840b6c8',
			e: '053a47b5-37b0-4eed-b20b-481c7fc2e14f',
		},
		Rentik1: '50fff5da-3485-4fef-969c-53109c90b4c7',
		Rentik2: '73c375d3-f2a1-4b66-8ad1-a6b35f8537d1',
		WAIIS: '019a0137-db65-7bea-8a10-face354e5721',
	};
	private apiKeyInt: string = 'asfsafasfasfasfasfasfasfa';
	private apiKeyIntRentik: string = 'eYBikIuDOuVKdAiJJ5LjAZZmKmfYa1FS4ph3YaOc';
	private apiKeyWAIIS: string = 'nK8sT2vQwR4mXaL9BfYz7HcUdP3JeS6qZ0GbVxYp';
	public loading: string = '';
	public securityCode: string = localStorage.getItem(LocalStorageKeys.security_code) || '';

	constructor(
		private testsService: TestsService,
		private auth: AuthService,
		private router: Router,
		private route: ActivatedRoute,
		public designService: DesignService,
	) {
		this.route.paramMap.subscribe((params) => {
			const id = params.get('id');
			if (id === '1') {
				this.loginProfile(this.profiles.es.pwcsa);
			} else if (id === '2') {
				this.loginProfile(this.profiles.es.pwcsTest2);
			} else if (id === 'marketing_demo') {
				this.loginProfile(this.profiles.es.pwcsMarketingDemo);
			}
			// Aquí puedes usar this.routeId como necesites
		});
	}

	public loginProfile(profile: string): void {
		if (profile) {
			this.loading = 'Cargando el proceso...';
			let apiKey = this.apiKeyInt;
			if (profile === this.profiles.Rentik1 || profile === this.profiles.Rentik2) {
				apiKey = this.apiKeyIntRentik;
			} else if (profile === this.profiles.WAIIS) {
				apiKey = this.apiKeyWAIIS;
			}

			this.testsService
				.loginProfile({
					api_key: apiKey,
					profile_uuid: profile,
					short_url_pwcs: false,
				})
				.subscribe({
					next: (response: {
						message: string;
						expireAt: number;
						process: string;
						company: string;
						pwcs_url: string;
					}) => {
						if ((environment as any).isLocal) {
							const params = new URL(response.pwcs_url).searchParams;
							const token = params.get('tkn');
							this.auth.clearAccessToken();
							setTimeout(() => {
								this.loading = '';
								this.auth.setAccessToken(token);
								this.router.navigate(['/']);
							}, 100);
						} else {
							this.loading = '';
							window.location.href = response.pwcs_url;
						}
					},
					error: () => {
						this.loading = '';
					},
				});
		}
	}
}
